module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shift-class"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shift_manage"
    }
  }, [_vm._v(_vm._s(_vm.$t('ShiftManage')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('ShiftClass')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('ShiftClass')))]), _c('div', {
    staticClass: "row text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v("戻る")])])]), (_vm.isSystemManagement) ? _c('div', {
    staticClass: "row margin-top padding-bottom"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchShop),
      expression: "searchShop"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        _vm.searchShop = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.search]
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }), _vm._l((_vm.shops), function(shop) {
    return [_c('option', {
      domProps: {
        "value": shop.id
      }
    }, [_vm._v(_vm._s(shop.attributes['shop-name']))])]
  })], 2)])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [(_vm.searchCallbackFlag && (_vm.shiftClassHayaHoList != null && _vm.shiftClassHayaHoList.length > 0)) ? _c('div', {
    staticClass: "shift-hayaho"
  }, [_vm._m(1), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _c('tbody', [_vm._l((_vm.hayaHoDefault), function(hayaHoDef, index) {
    return _c('tr', [_c('td', [_vm._v("フル勤務")]), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_hayaho -default"
    }, [_vm._v(_vm._s(hayaHoDef.view_name))])]), _c('td', [_vm._v(_vm._s(hayaHoDef.select_name))]), _c('td', [(_vm.hayaHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHoDef.time_from_hh),
        expression: "hayaHoDef.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHoDef.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHoDef.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHoDef.time_from_mm),
        expression: "hayaHoDef.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHoDef.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHoDef.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHoDef.time_to_hh),
        expression: "hayaHoDef.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHoDef.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHoDef.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHoDef.time_to_mm),
        expression: "hayaHoDef.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHoDef.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHoDef.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(hayaHoDef) > 0),
        expression: "checkTimeFormat(hayaHoDef) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(hayaHoDef)))])]) : _c('span', [_vm._v(_vm._s(hayaHoDef.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(hayaHoDef.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(hayaHoDef.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(hayaHoDef.time_to_mm))])])]), _c('td', [(_vm.hayaHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHoDef.break_time),
        expression: "hayaHoDef.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHoDef.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHoDef.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(hayaHoDef.break_time)),
        expression: "isBlank(hayaHoDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(hayaHoDef.break_time)),
        expression: "!isNumerical(hayaHoDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(hayaHoDef.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.hayaHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHoDef.content),
        expression: "hayaHoDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(hayaHoDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHoDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(hayaHoDef.content))])]), _c('td', [(_vm.hayaHoDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('hayaHoDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorDefault('hayaHoDefault', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('hayaHoDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(3), _vm._l((_vm.hayaHoOptions), function(hayaHo, index) {
    return _c('tr', [_c('td', [_vm._v("部分勤務")]), _vm._m(4, true), _c('td', [(_vm.hayaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.select_name),
        expression: "hayaHo.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(hayaHo.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(hayaHo.select_name)),
        expression: "isBlank(hayaHo.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(hayaHo)),
        expression: "existSameSelectName(hayaHo)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(hayaHo.select_name))])]), _c('td', [(_vm.hayaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.time_from_hh),
        expression: "hayaHo.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHo.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.time_from_mm),
        expression: "hayaHo.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHo.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.time_to_hh),
        expression: "hayaHo.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHo.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.time_to_mm),
        expression: "hayaHo.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHo.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(hayaHo) > 0),
        expression: "checkTimeFormat(hayaHo) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(hayaHo)))])]) : _c('span', [_vm._v(_vm._s(hayaHo.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(hayaHo.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(hayaHo.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(hayaHo.time_to_mm))])])]), _c('td', [(_vm.hayaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.break_time),
        expression: "hayaHo.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaHo.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(hayaHo.break_time)),
        expression: "isBlank(hayaHo.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(hayaHo.break_time)),
        expression: "!isNumerical(hayaHo.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(hayaHo.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.hayaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaHo.content),
        expression: "hayaHo.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(hayaHo.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaHo.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(hayaHo.content))])]), _c('td', [(_vm.hayaHoOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('hayaHoOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.hayaHoOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(hayaHo.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.hayaHoOptionEditIndex === index) ? _c('dif', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorOption('a_haya_ho', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('a_haya_ho', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()], 1)])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('hayaHoOptions', 'hayaHoOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(5)])]) : _vm._e(), (_vm.searchCallbackFlag && (_vm.shiftClassOsoHoList != null && _vm.shiftClassOsoHoList.length > 0)) ? _c('div', {
    staticClass: "shift-osoho"
  }, [_vm._m(6), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(7), _c('tbody', [_vm._l((_vm.osoHoDefault), function(osoHoDef, index) {
    return _c('tr', [_c('td', [_vm._v("フル勤務")]), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_osoho -default"
    }, [_vm._v(_vm._s(osoHoDef.view_name))])]), _c('td', [_vm._v(_vm._s(osoHoDef.select_name))]), _c('td', [(_vm.osoHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHoDef.time_from_hh),
        expression: "osoHoDef.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHoDef.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHoDef.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHoDef.time_from_mm),
        expression: "osoHoDef.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHoDef.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHoDef.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHoDef.time_to_hh),
        expression: "osoHoDef.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHoDef.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHoDef.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHoDef.time_to_mm),
        expression: "osoHoDef.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHoDef.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHoDef.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(osoHoDef) > 0),
        expression: "checkTimeFormat(osoHoDef) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(osoHoDef)))])]) : _c('span', [_vm._v(_vm._s(osoHoDef.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(osoHoDef.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(osoHoDef.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(osoHoDef.time_to_mm))])])]), _c('td', [(_vm.osoHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHoDef.break_time),
        expression: "osoHoDef.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHoDef.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHoDef.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(osoHoDef.break_time)),
        expression: "isBlank(osoHoDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(osoHoDef.break_time)),
        expression: "!isNumerical(osoHoDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(osoHoDef.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.osoHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHoDef.content),
        expression: "osoHoDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(osoHoDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHoDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(osoHoDef.content))])]), _c('td', [(_vm.osoHoDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('osoHoDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorDefault('osoHoDefault', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('osoHoDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(8), _vm._l((_vm.osoHoOptions), function(osoHo, index) {
    return _c('tr', [_c('td', [_vm._v("部分勤務")]), _vm._m(9, true), _c('td', [(_vm.osoHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.select_name),
        expression: "osoHo.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(osoHo.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(osoHo.select_name)),
        expression: "isBlank(osoHo.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(osoHo)),
        expression: "existSameSelectName(osoHo)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(osoHo.select_name))])]), _c('td', [(_vm.osoHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.time_from_hh),
        expression: "osoHo.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHo.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.time_from_mm),
        expression: "osoHo.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHo.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.time_to_hh),
        expression: "osoHo.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHo.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.time_to_mm),
        expression: "osoHo.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHo.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(osoHo) > 0),
        expression: "checkTimeFormat(osoHo) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(osoHo)))])]) : _c('span', [_vm._v(_vm._s(osoHo.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(osoHo.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(osoHo.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(osoHo.time_to_mm))])])]), _c('td', [(_vm.osoHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.break_time),
        expression: "osoHo.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoHo.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(osoHo.break_time)),
        expression: "isBlank(osoHo.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(osoHo.break_time)),
        expression: "!isNumerical(osoHo.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(osoHo.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.osoHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoHo.content),
        expression: "osoHo.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(osoHo.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoHo.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(osoHo.content))])]), _c('td', [(_vm.osoHoOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('osoHoOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.osoHoOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(osoHo.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.osoHoOptionEditIndex === index) ? _c('div', [(_vm.osoHoOptionEditIndex === index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorOption('d_oso_ho', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('d_oso_ho', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]) : _vm._e(), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()])])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('osoHoOptions', 'osoHoOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(10)])]) : _vm._e(), (_vm.searchCallbackFlag && (_vm.shiftClassNakaHoList != null && _vm.shiftClassNakaHoList.length > 0)) ? _c('div', {
    staticClass: "shift-nakaho"
  }, [_vm._m(11), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(12), _c('tbody', [_vm._l((_vm.nakaHoDefault), function(nakaHoDef, index) {
    return _c('tr', [_c('td', [_vm._v("フル勤務")]), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_nakaho -default"
    }, [_vm._v(_vm._s(nakaHoDef.view_name))])]), _c('td', [_vm._v(_vm._s(nakaHoDef.select_name))]), _c('td', [(_vm.nakaHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHoDef.time_from_hh),
        expression: "nakaHoDef.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHoDef.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHoDef.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHoDef.time_from_mm),
        expression: "nakaHoDef.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHoDef.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHoDef.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHoDef.time_to_hh),
        expression: "nakaHoDef.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHoDef.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHoDef.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHoDef.time_to_mm),
        expression: "nakaHoDef.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHoDef.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHoDef.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(nakaHoDef) > 0),
        expression: "checkTimeFormat(nakaHoDef) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(nakaHoDef)))])]) : _c('span', [_vm._v(_vm._s(nakaHoDef.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(nakaHoDef.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(nakaHoDef.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(nakaHoDef.time_to_mm))])])]), _c('td', [(_vm.nakaHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHoDef.break_time),
        expression: "nakaHoDef.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHoDef.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHoDef.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(nakaHoDef.break_time)),
        expression: "isBlank(nakaHoDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(nakaHoDef.break_time)),
        expression: "!isNumerical(nakaHoDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(nakaHoDef.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.nakaHoDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHoDef.content),
        expression: "nakaHoDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(nakaHoDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHoDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(nakaHoDef.content))])]), _c('td', [(_vm.nakaHoDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('nakaHoDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorDefault('nakaHoDefault', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('nakaHoDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(13), _vm._l((_vm.nakaHoOptions), function(nakaHo, index) {
    return _c('tr', [_c('td', [_vm._v("部分勤務")]), _vm._m(14, true), _c('td', [(_vm.nakaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.select_name),
        expression: "nakaHo.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(nakaHo.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(nakaHo.select_name)),
        expression: "isBlank(nakaHo.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(nakaHo)),
        expression: "existSameSelectName(nakaHo)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(nakaHo.select_name))])]), _c('td', [(_vm.nakaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.time_from_hh),
        expression: "nakaHo.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHo.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.time_from_mm),
        expression: "nakaHo.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHo.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.time_to_hh),
        expression: "nakaHo.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHo.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.time_to_mm),
        expression: "nakaHo.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHo.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(nakaHo) > 0),
        expression: "checkTimeFormat(nakaHo) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(nakaHo)))])]) : _c('span', [_vm._v(_vm._s(nakaHo.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(nakaHo.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(nakaHo.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(nakaHo.time_to_mm))])])]), _c('td', [(_vm.nakaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.break_time),
        expression: "nakaHo.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(nakaHo.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(nakaHo.break_time)),
        expression: "isBlank(nakaHo.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(nakaHo.break_time)),
        expression: "!isNumerical(nakaHo.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(nakaHo.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.nakaHoOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nakaHo.content),
        expression: "nakaHo.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(nakaHo.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nakaHo.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(nakaHo.content))])]), _c('td', [(_vm.nakaHoOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('nakaHoOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.nakaHoOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(nakaHo.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.nakaHoOptionEditIndex === index) ? _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorOption('c_naka_ho', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('c_naka_ho', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()])])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('nakaHoOptions', 'nakaHoOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(15)])]) : _vm._e(), (_vm.searchCallbackFlag && (_vm.shiftClassHayaKaList != null && _vm.shiftClassHayaKaList.length > 0)) ? _c('div', {
    staticClass: "shift-hayaka"
  }, [_vm._m(16), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(17), _c('tbody', [_vm._l((_vm.hayaKaDefault), function(hayaKaDef, index) {
    return _c('tr', [_c('td', [_vm._v("フル勤務")]), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_hayaka -default"
    }, [_vm._v(_vm._s(hayaKaDef.view_name))])]), _c('td', [_vm._v(_vm._s(hayaKaDef.select_name))]), _c('td', [(_vm.hayaKaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKaDef.time_from_hh),
        expression: "hayaKaDef.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKaDef.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKaDef.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKaDef.time_from_mm),
        expression: "hayaKaDef.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKaDef.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKaDef.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKaDef.time_to_hh),
        expression: "hayaKaDef.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKaDef.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKaDef.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKaDef.time_to_mm),
        expression: "hayaKaDef.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKaDef.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKaDef.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(hayaKaDef) > 0),
        expression: "checkTimeFormat(hayaKaDef) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(hayaKaDef)))])]) : _c('span', [_vm._v(_vm._s(hayaKaDef.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(hayaKaDef.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(hayaKaDef.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(hayaKaDef.time_to_mm))])])]), _c('td', [(_vm.hayaKaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKaDef.break_time),
        expression: "hayaKaDef.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKaDef.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKaDef.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(hayaKaDef.break_time)),
        expression: "isBlank(hayaKaDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(hayaKaDef.break_time)),
        expression: "!isNumerical(hayaKaDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(hayaKaDef.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.hayaKaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKaDef.content),
        expression: "hayaKaDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(hayaKaDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKaDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(hayaKaDef.content))])]), _c('td', [(_vm.hayaKaDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('hayaKaDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorDefault('hayaKaDefault', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('hayaKaDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(18), _vm._l((_vm.hayaKaOptions), function(hayaKa, index) {
    return _c('tr', [_c('td', [_vm._v("部分勤務")]), _vm._m(19, true), _c('td', [(_vm.hayaKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.select_name),
        expression: "hayaKa.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(hayaKa.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(hayaKa.select_name)),
        expression: "isBlank(hayaKa.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(hayaKa)),
        expression: "existSameSelectName(hayaKa)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(hayaKa.select_name))])]), _c('td', [(_vm.hayaKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.time_from_hh),
        expression: "hayaKa.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKa.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.time_from_mm),
        expression: "hayaKa.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKa.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.time_to_hh),
        expression: "hayaKa.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKa.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.time_to_mm),
        expression: "hayaKa.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKa.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(hayaKa) > 0),
        expression: "checkTimeFormat(hayaKa) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(hayaKa)))])]) : _c('span', [_vm._v(_vm._s(hayaKa.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(hayaKa.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(hayaKa.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(hayaKa.time_to_mm))])])]), _c('td', [(_vm.hayaKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.break_time),
        expression: "hayaKa.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(hayaKa.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(hayaKa.break_time)),
        expression: "isBlank(hayaKa.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(hayaKa.break_time)),
        expression: "!isNumerical(hayaKa.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(hayaKa.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.hayaKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (hayaKa.content),
        expression: "hayaKa.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(hayaKa.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          hayaKa.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(hayaKa.content))])]), _c('td', [(_vm.hayaKaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('hayaKaOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.hayaKaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(hayaKa.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.hayaKaOptionEditIndex === index) ? _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorOption('b_haya_ka', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('b_haya_ka', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()])])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('hayaKaOptions', 'hayaKaOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(20)])]) : _vm._e(), (_vm.searchCallbackFlag && (_vm.shiftClassOsoKaList != null && _vm.shiftClassOsoKaList.length > 0)) ? _c('div', {
    staticClass: "shift-osoka"
  }, [_vm._m(21), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(22), _c('tbody', [_vm._l((_vm.osoKaDefault), function(osoKaDef, index) {
    return _c('tr', [_c('td', [_vm._v("フル勤務")]), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_osoka -default"
    }, [_vm._v(_vm._s(osoKaDef.view_name))])]), _c('td', [_vm._v(_vm._s(osoKaDef.select_name))]), _c('td', [(_vm.osoKaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKaDef.time_from_hh),
        expression: "osoKaDef.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKaDef.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKaDef.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKaDef.time_from_mm),
        expression: "osoKaDef.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKaDef.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKaDef.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKaDef.time_to_hh),
        expression: "osoKaDef.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKaDef.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKaDef.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKaDef.time_to_mm),
        expression: "osoKaDef.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKaDef.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKaDef.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(osoKaDef) > 0),
        expression: "checkTimeFormat(osoKaDef) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(osoKaDef)))])]) : _c('span', [_vm._v(_vm._s(osoKaDef.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(osoKaDef.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(osoKaDef.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(osoKaDef.time_to_mm))])])]), _c('td', [(_vm.osoKaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKaDef.break_time),
        expression: "osoKaDef.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKaDef.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKaDef.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(osoKaDef.break_time)),
        expression: "isBlank(osoKaDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(osoKaDef.break_time)),
        expression: "!isNumerical(osoKaDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(osoKaDef.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.osoKaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKaDef.content),
        expression: "osoKaDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(osoKaDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKaDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(osoKaDef.content))])]), _c('td', [(_vm.osoKaDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('osoKaDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorDefault('osoKaDefault', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('osoKaDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(23), _vm._l((_vm.osoKaOptions), function(osoKa, index) {
    return _c('tr', [_c('td', [_vm._v("部分勤務")]), _vm._m(24, true), _c('td', [(_vm.osoKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.select_name),
        expression: "osoKa.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(osoKa.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(osoKa.select_name)),
        expression: "isBlank(osoKa.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(osoKa)),
        expression: "existSameSelectName(osoKa)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(osoKa.select_name))])]), _c('td', [(_vm.osoKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.time_from_hh),
        expression: "osoKa.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKa.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.time_from_mm),
        expression: "osoKa.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKa.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.time_to_hh),
        expression: "osoKa.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKa.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.time_to_mm),
        expression: "osoKa.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKa.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(osoKa) > 0),
        expression: "checkTimeFormat(osoKa) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(osoKa)))])]) : _c('span', [_vm._v(_vm._s(osoKa.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(osoKa.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(osoKa.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(osoKa.time_to_mm))])])]), _c('td', [(_vm.osoKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.break_time),
        expression: "osoKa.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(osoKa.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(osoKa.break_time)),
        expression: "isBlank(osoKa.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(osoKa.break_time)),
        expression: "!isNumerical(osoKa.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(osoKa.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.osoKaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (osoKa.content),
        expression: "osoKa.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(osoKa.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          osoKa.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(osoKa.content))])]), _c('td', [(_vm.osoKaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('osoKaOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.osoKaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(osoKa.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.osoKaOptionEditIndex === index) ? _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorOption('e_oso_ka', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('e_oso_ka', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()])])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('osoKaOptions', 'osoKaOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(25)])]) : _vm._e(), (_vm.searchCallbackFlag && (_vm.shiftClassKyukaList != null && _vm.shiftClassKyukaList.length > 0)) ? _c('div', {
    staticClass: "shift-kyuka"
  }, [_vm._m(26), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(27), _c('tbody', [_vm._l((_vm.kyukaDefault), function(kyukaDef, index) {
    return _c('tr', [_c('td'), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_kyuka -default"
    }, [_vm._v(_vm._s(kyukaDef.view_name))])]), _c('td', [_vm._v(_vm._s(kyukaDef.select_name))]), _vm._m(28, true), _vm._m(29, true), _c('td', [(_vm.kyukaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kyukaDef.content),
        expression: "kyukaDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(kyukaDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          kyukaDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(kyukaDef.content))])]), _c('td', [(_vm.kyukaDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('kyukaDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('kyukaDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(30), _vm._l((_vm.kyukaOptions), function(kyuka, index) {
    return _c('tr', [_c('td'), _c('td', [(_vm.kyukaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kyuka.view_name),
        expression: "kyuka.view_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "表示名",
        "maxlength": "3"
      },
      domProps: {
        "value": _vm._s(kyuka.view_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          kyuka.view_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(kyuka.view_name)),
        expression: "isBlank(kyuka.view_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]) : _c('div', {
      staticClass: "shift-icon shift-icon_kyuka"
    }, [_vm._v(_vm._s(kyuka.view_name))])]), _c('td', [(_vm.kyukaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kyuka.select_name),
        expression: "kyuka.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(kyuka.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          kyuka.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(kyuka.select_name)),
        expression: "isBlank(kyuka.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(kyuka)),
        expression: "existSameSelectName(kyuka)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(kyuka.select_name))])]), _vm._m(31, true), _vm._m(32, true), _c('td', [(_vm.kyukaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kyuka.content),
        expression: "kyuka.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(kyuka.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          kyuka.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(kyuka.content))])]), _c('td', [(_vm.kyukaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('kyukaOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.kyukaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(kyuka.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.kyukaOptionEditIndex === index) ? _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isBlank(kyuka.select_name) || _vm.isBlank(kyuka.view_name)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('f_kyuka', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()])])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('kyukaOptions', 'kyukaOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(33)])]) : _vm._e(), (_vm.searchCallbackFlag && (_vm.shiftClassSonotaList != null && _vm.shiftClassSonotaList.length > 0)) ? _c('div', {
    staticClass: "shift-sonota"
  }, [_vm._m(34), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(35), _c('tbody', [_vm._l((_vm.sonotaDefault), function(sonotaDef, index) {
    return _c('tr', [_c('td', [_vm._v("フル勤務")]), _c('td', [_c('div', {
      staticClass: "shift-icon shift-icon_sonota -default"
    }, [_vm._v(_vm._s(sonotaDef.view_name))])]), _c('td', [_vm._v(_vm._s(sonotaDef.select_name))]), _c('td', [(_vm.sonotaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonotaDef.time_from_hh),
        expression: "sonotaDef.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonotaDef.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonotaDef.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonotaDef.time_from_mm),
        expression: "sonotaDef.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonotaDef.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonotaDef.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonotaDef.time_to_hh),
        expression: "sonotaDef.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonotaDef.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonotaDef.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonotaDef.time_to_mm),
        expression: "sonotaDef.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonotaDef.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonotaDef.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(sonotaDef) > 0),
        expression: "checkTimeFormat(sonotaDef) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(sonotaDef)))])]) : _c('span', [_vm._v(_vm._s(sonotaDef.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(sonotaDef.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(sonotaDef.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(sonotaDef.time_to_mm))])])]), _c('td', [(_vm.sonotaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonotaDef.break_time),
        expression: "sonotaDef.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonotaDef.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonotaDef.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(sonotaDef.break_time)),
        expression: "isBlank(sonotaDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(sonotaDef.break_time)),
        expression: "!isNumerical(sonotaDef.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(sonotaDef.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.sonotaDefaultEdit === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonotaDef.content),
        expression: "sonotaDef.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(sonotaDef.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonotaDef.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(sonotaDef.content))])]), _c('td', [(_vm.sonotaDefaultEdit !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableDefaultEdit('sonotaDefaultEdit', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorDefault('sonotaDefault', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveDefault('sonotaDefault', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])])])])
  }), _vm._m(36), _vm._l((_vm.sonotaOptions), function(sonota, index) {
    return _c('tr', [_c('td', [_vm._v("部分勤務")]), _c('td', [(_vm.sonotaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.view_name),
        expression: "sonota.view_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "表示名",
        "maxlength": "3"
      },
      domProps: {
        "value": _vm._s(sonota.view_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.view_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(sonota.view_name)),
        expression: "isBlank(sonota.view_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]) : _c('div', {
      staticClass: "shift-icon shift-icon_sonota"
    }, [_vm._v(_vm._s(sonota.view_name))])]), _c('td', [(_vm.sonotaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.select_name),
        expression: "sonota.select_name"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "選択肢名",
        "maxlength": "10"
      },
      domProps: {
        "value": _vm._s(sonota.select_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.select_name = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(sonota.select_name)),
        expression: "isBlank(sonota.select_name)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.existSameSelectName(sonota)),
        expression: "existSameSelectName(sonota)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.same_selected_value')))])]) : _c('span', [_vm._v(_vm._s(sonota.select_name))])]), _c('td', [(_vm.sonotaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.time_from_hh),
        expression: "sonota.time_from_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "09",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonota.time_from_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.time_from_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.time_from_mm),
        expression: "sonota.time_from_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonota.time_from_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.time_from_mm = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 〜 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.time_to_hh),
        expression: "sonota.time_to_hh"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "18",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonota.time_to_hh)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.time_to_hh = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" : ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.time_to_mm),
        expression: "sonota.time_to_mm"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "00",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonota.time_to_mm)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.time_to_mm = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkTimeFormat(sonota) > 0),
        expression: "checkTimeFormat(sonota) > 0"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.getTimeFormatError(sonota)))])]) : _c('span', [_vm._v(_vm._s(sonota.time_from_hh)), _c('span', [_vm._v(" : " + _vm._s(sonota.time_from_mm))]), _c('span', [_vm._v(" 〜 " + _vm._s(sonota.time_to_hh))]), _c('span', [_vm._v(" : " + _vm._s(sonota.time_to_mm))])])]), _c('td', [(_vm.sonotaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.break_time),
        expression: "sonota.break_time"
      }],
      staticClass: "shift-class__input",
      attrs: {
        "type": "text",
        "size": "2",
        "placeholder": "60",
        "maxlength": "2"
      },
      domProps: {
        "value": _vm._s(sonota.break_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.break_time = $event.target.value
        }
      }
    }), _c('span', [_vm._v(" 分")]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isBlank(sonota.break_time)),
        expression: "isBlank(sonota.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))]), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isNumerical(sonota.break_time)),
        expression: "!isNumerical(sonota.break_time)"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.invalid_number')))])]) : _c('span', [_vm._v(_vm._s(sonota.break_time)), _c('span', [_vm._v(" 分")])])]), _c('td', [(_vm.sonotaOptionEditIndex === index) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (sonota.content),
        expression: "sonota.content"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "text",
        "placeholder": "テキストメモ",
        "maxlength": "25"
      },
      domProps: {
        "value": _vm._s(sonota.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          sonota.content = $event.target.value
        }
      }
    })]) : _c('span', [_vm._v(_vm._s(sonota.content))])]), _c('td', [(_vm.sonotaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickEnableOptionEdit('sonotaOptionEditIndex', index)
        }
      }
    }, [_c('span', [_vm._v("編集")])]) : _vm._e(), (_vm.sonotaOptionEditIndex !== index) ? _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.isEditing
      },
      on: {
        "click": function($event) {
          _vm.onClickOptionDelete(sonota.id)
        }
      }
    }, [_c('span', [_vm._v("削除")])]) : _vm._e(), (_vm.sonotaOptionEditIndex === index) ? _c('div', [_c('a', {
      staticClass: "btn btn-info margin-right",
      class: {
        disabled: _vm.isInputErrorOption('g_sonota', index)
      },
      on: {
        "click": function($event) {
          _vm.onClickSaveOption('g_sonota', index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o"
    }), _c('span', [_vm._v("保存")])]), _c('a', {
      staticClass: "btn btn-danger margin-right",
      on: {
        "click": function($event) {
          _vm.onClickCancel()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    }), _c('span', [_vm._v("キャンセル")])])]) : _vm._e()])])
  }), (!_vm.isEditing) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_c('a', {
    staticClass: "text-info",
    on: {
      "click": function($event) {
        _vm.onClickAddOption('sonotaOptions', 'sonotaOptionEditIndex')
      }
    }
  }, [_vm._v("＋選択肢を新しく登録する")])])]) : _vm._e()], 2)]), _vm._m(37), _c('div', {
    staticClass: "row text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v("戻る")])])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2"
  }, [_c('label', [_vm._v("店舗:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("「早番・ホール」")]), _c('small', [_vm._v("として人数をカウントする選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_hayaho"
  }, [_vm._v("早番")])]), _c('td', [_vm._v("早番9-11*木")]), _c('td', [_vm._v("09 : 00 〜 11 : 00")]), _c('td', [_vm._v("60 分")]), _c('td', [_vm._v("田中太郎の希望時間帯(木曜日以外)")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_c('div', {
    staticClass: "shift-icon shift-icon_hayaho"
  }, [_vm._v("早番")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_hayaho"
  }, [_vm._v("早番")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("「遅番・ホール」")]), _c('small', [_vm._v("として人数をカウントする選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_osoho"
  }, [_vm._v("遅番")])]), _c('td', [_vm._v("遅番16-20*木")]), _c('td', [_vm._v("16 : 00 〜 20 : 00")]), _c('td', [_vm._v("60 分")]), _c('td', [_vm._v("田中太郎の希望時間帯(木曜日以外)")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_c('div', {
    staticClass: "shift-icon shift-icon_osoho"
  }, [_vm._v("遅番")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_osoho"
  }, [_vm._v("遅番")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("「中番・ホール」")]), _c('small', [_vm._v("として人数をカウントする選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_nakaho"
  }, [_vm._v("中番")])]), _c('td', [_vm._v("中番14-17*木")]), _c('td', [_vm._v("14 : 00 〜 17 : 00")]), _c('td', [_vm._v("60 分")]), _c('td', [_vm._v("田中太郎の希望時間帯(木曜日以外)")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_c('div', {
    staticClass: "shift-icon shift-icon_nakaho"
  }, [_vm._v("中番")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_nakaho"
  }, [_vm._v("中番")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("「早番・カウンター」")]), _c('small', [_vm._v("として人数をカウントする選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_hayaka"
  }, [_vm._v("早番カ")])]), _c('td', [_vm._v("早番カ9-11*木")]), _c('td', [_vm._v("09 : 00 〜 11 : 00")]), _c('td', [_vm._v("60 分")]), _c('td', [_vm._v("田中花子の希望時間帯(木曜日以外)")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_c('div', {
    staticClass: "shift-icon shift-icon_hayaka"
  }, [_vm._v("早番カ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_hayaka"
  }, [_vm._v("早番カ")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v("「遅番・カウンター」")]), _c('small', [_vm._v("として人数をカウントする選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_osoka"
  }, [_vm._v("遅番カ")])]), _c('td', [_vm._v("遅番カ16-20*木")]), _c('td', [_vm._v("16 : 00 〜 20 : 00")]), _c('td', [_vm._v("60 分")]), _c('td', [_vm._v("田中花子の希望時間帯(木曜日以外)")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_c('div', {
    staticClass: "shift-icon shift-icon_osoka"
  }, [_vm._v("遅番カ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_osoka"
  }, [_vm._v("遅番カ")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v(" 休暇 ")]), _c('small', [_vm._v("各種休みの選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("--"), _c('span', [_vm._v(" : --")]), _c('span', [_vm._v(" 〜 --")]), _c('span', [_vm._v(" : --")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("--"), _c('span', [_vm._v(" 分")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_kyuka"
  }, [_vm._v("休暇")])]), _c('td', [_vm._v("特別休暇")]), _c('td', [_vm._v("-- : -- 〜 -- : --")]), _c('td', [_vm._v("-- 分")]), _c('td', [_vm._v("特別な休暇の場合")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("--"), _c('span', [_vm._v(" : --")]), _c('span', [_vm._v(" 〜 --")]), _c('span', [_vm._v(" : --")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("--"), _c('span', [_vm._v(" 分")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_kyuka"
  }, [_vm._v("休暇")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_vm._v(" その他 ")]), _c('small', [_vm._v("人数をカウントしない選択肢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th'), _c('th', [_vm._v("シフト表での表示")]), _c('th', [_vm._v("選択肢名")]), _c('th', [_vm._v("時間帯")]), _c('th', [_vm._v("休憩時間")]), _c('th', [_vm._v("備考(メモ)")]), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('td', [_vm._v("記入例")]), _c('td', [_c('div', {
    staticClass: "shift-icon shift-icon_sonota"
  }, [_vm._v("その他")])]), _c('td', [_vm._v("本部の作業")]), _c('td', [_vm._v("09 : 00 〜 17 : 00")]), _c('td', [_vm._v("60 分")]), _c('td', [_vm._v("本部作業の場合")]), _c('td')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('span', [_vm._v("※ 滅多に発生しない、イレギュラーな勤務時間などは、こちらに「選択肢として登録」する必要は")]), _c('strong', [_vm._v("ありません。")]), _c('br'), _c('span', [_vm._v("その場合、「シフト表作成画面」で時間帯情報を編集することができます。")])])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('div', {
    staticClass: "shift-icon shift-icon_changed shift-icon_sonota"
  }, [_vm._v("その他")])]), _c('div', {
    staticClass: "col-md-10"
  }, [_c('p', [_vm._v("シフト作成表上で時間帯を変更したものは左のように丸で囲われて表示されます。")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01790d28!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/shift-class.pug
// module id = 737
// module chunks = 1